// extracted by mini-css-extract-plugin
export default {"cardImageSizer":"style_cardImageSizer__2BDOf","cardImage":"style_cardImage__tQRp8","fullBlock":"style_fullBlock__somLG","cardCarosel":"style_cardCarosel__lIKiy"};